//import Libraries
import React, { Component } from 'react';
import {connect} from 'react-redux';

import {Parser} from 'json2csv'

//import Components
import {Container, Row, Col, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';
import Loading from '../../../components/Loading/Loading'; 
import OrderPagination from './OrderPagination';
import * as productsActions from '../ProductManager/Category/Product/actions/productActions'; 
import * as orderActions from './actions/ordersAction';

import {orderStatus} from './constants/constants';

//import Styles
import '../Admin.css'


class OrderManager extends Component{
    constructor(props) {
        super(props);
        this.state = {
            filterOpen : false,
            sortOpen : false,
            sortSelected : 1,
            filterSelected : [1, 2, 3, 4],
        }
    }

    orderToCSV = (orders) => {
        const sortedOrders = this.sortOrder(this.props.orders, this.props.accounts);
        const filteredOrders = this.filterOrders(sortedOrders);

        const fields = ['Time', 'Customer_Name', 'Company', 'Product-Quantity', 'Status', 'Message'];
        const toCSV = filteredOrders.map((obj, idx)=>{
            let {orderTime, uid, cart, message, status, id} = obj;

            let tempCustomer = this.props.accounts.find(x => x.uid === uid);
            let tempCart = cart.map((o, i)=>{
                return this.props.products.find(x => x.id === o.id).name.ko+" - "+o.quantity+"EA"
            })
            // console.log(tempCart);

            let csvTime = `${orderTime.day.year}.${orderTime.day.month}.${orderTime.day.date} - ${orderTime.time.hour}:${orderTime.time.minute}:${orderTime.time.second}`;
            let csvCustomerName = tempCustomer.fullName;
            let csvCustomerCompany = tempCustomer.company;
            let csvCart = tempCart;

            return {
                "Time": csvTime, 
                'Customer_Name': csvCustomerName.toString(), 
                'Company': csvCustomerCompany,
                'Product-Quantity': csvCart.join("\n"), 
                'Status': status, 
                'Message': message
            };
        })

    
        const json2csvParser = new Parser(fields);
        const csv = json2csvParser.parse(toCSV);
        const downloadData = "text/json;charset=utf-8,\uFEFF" + encodeURIComponent(csv);

        const link = document.createElement('a');
        link.href = "data:`" + downloadData + `"`;
        link.download="order.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    onSortSelected = (sort) => {
        this.setState({
            sortSelected : sort
        })
    }
    onFilterSelected = (filter) => {
        const filterSelected = [...this.state.filterSelected];
        const index = this.state.filterSelected.indexOf(filter);
        if(index < 0) {
            filterSelected.push(filter);
        } else {
            filterSelected.splice(index, 1);
        }
        this.setState({
            filterSelected : [...filterSelected]
        })
    }

    toggleFilterOpen = () => {
        this.setState(prevState => ({
            filterOpen : !prevState.filterOpen
        }))
    }
    toggleSortOpen = () => {
        this.setState(prevState => ({
            sortOpen : !prevState.sortOpen
        }))
    }

    getFilterStrings = () => {
        let filterStrings = [];
        const {filterSelected} = this.state;

        orderStatus.map((status, index) => {
            if(filterSelected.includes(index + 1)) {
                filterStrings.push(status);
            }
        })
        return filterStrings;
    }

    sortOrder = (orders, accounts) => {
        let copy = [...orders];
        if(this.state.sortSelected === 2) {
            copy.sort((a, b) => {
                const aIndex = accounts.map(acc => acc.uid).indexOf(a.uid)
                const bIndex = accounts.map(acc => acc.uid).indexOf(b.uid)

                const nameA = accounts[aIndex].lastName;
                const nameB = accounts[bIndex].lastName;

                if (nameA < nameB) {return -1}
                if (nameA > nameB) {return 1;}
                return 0;
            })

        }else if(this.state.sortSelected === 3) {
            copy.sort((a, b) => {
                const aIndex = accounts.map(acc => acc.uid).indexOf(a.uid)
                const bIndex = accounts.map(acc => acc.uid).indexOf(b.uid)

                const nameA = accounts[aIndex].company;
                const nameB = accounts[bIndex].company;
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            })
        }
        return copy;
    }

    filterOrder = (order, filters) => {
        for(let i = 0; i < filters.length; ++i) {
            if(order.status === filters[i]) {
                return true;
            }
        }
        return false;
    }

    filterOrders = (orders) => {
        const filters = this.getFilterStrings();
        let filteredOrders = [];
        orders.map((order) => {
            if(this.filterOrder(order, filters)) {
                filteredOrders.push(order);
            }
        })
        return filteredOrders;
    }

    render(){
        if(!this.props.orders || 
           !this.props.accounts || 
           !this.props.products) {
            return (
                <div className="admin-element">
                    <Loading text={'주문관리'} />
                </div>
            );
        }
        const {viewingPage, ids } = this.props;

        const sortedOrders = this.sortOrder(this.props.orders, this.props.accounts);
        const filteredOrders = this.filterOrders(sortedOrders);

        return (
            <div className="admin-element">
                <Container>
                    <h1>
                        주문관리
                    </h1>
                    <hr/>
                </Container>
                <Container className="CommandWrapper">
                    <Row>
                        <Col xs="3"> 
                            <Button 
                                color="light"
                                onClick={() => {
                                    this.orderToCSV();
                                }}
                            >
                                다운로드
                            </Button> 
                            <Button 
                                onClick={() => {
                                    window.print();
                                }}
                                color="light" 
                                outline
                            >
                                인쇄
                            </Button>
                        </Col>
                        <Col xs="6">
                            <Button 
                                className="float-right"
                                onClick={ () => this.props.onChangeOrderState(ids, "처리중")}
                                color="warning"
                                outline
                            >
                                처리중
                            </Button>
                            <Button 
                                className="float-right"
                                onClick={ () => this.props.onChangeOrderState(ids, "배송중")}
                                color="primary"
                                outline
                            >
                                배송중
                            </Button>
                            <Button 
                                className="float-right"
                                onClick={ () => this.props.onChangeOrderState(ids, "처리완료") }
                                color="success"

                                outline
                            >
                                처리완료
                            </Button>
                            <Button 
                                className="float-right"
                                onClick={ () => this.props.onChangeOrderState(ids, "주문반려") }
                                color="danger"
                                outline
                            >
                                주문반려
                            </Button>
                        </Col>
                        <Col xs="3">
                            <Dropdown className="float-right" isOpen={this.state.filterOpen} toggle={this.toggleFilterOpen}>
                                <DropdownToggle caret>
                                    필터
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem header>필터</DropdownItem>
                                    <DropdownItem 
                                        onClick={() => this.onFilterSelected(1)}
                                        active={this.state.filterSelected.includes(1)}
                                        >
                                        처리중
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => this.onFilterSelected(2)}
                                        active={this.state.filterSelected.includes(2)}
                                        >
                                        배송중
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => this.onFilterSelected(3)}
                                        active={this.state.filterSelected.includes(3)}
                                        >
                                        주문반려
                                    </DropdownItem>
                                    <DropdownItem
                                        onClick={() => this.onFilterSelected(4)}
                                        active={this.state.filterSelected.includes(4)}
                                        >
                                        처리완료
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                            <Dropdown className="float-right"isOpen={this.state.sortOpen} toggle={this.toggleSortOpen}>
                                <DropdownToggle caret>
                                    정렬
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem header>정렬</DropdownItem>
                                    <DropdownItem 
                                        onClick={() => this.onSortSelected(1)} 
                                        active={this.state.sortSelected === 1}
                                        >
                                        날짜
                                    </DropdownItem>
                                    {/* <DropdownItem 
                                        onClick={() => this.onSortSelected(2)} 
                                        active={this.state.sortSelected === 2}
                                        >
                                        보낸이
                                    </DropdownItem>
                                    <DropdownItem 
                                        onClick={() => this.onSortSelected(3)} 
                                        active={this.state.sortSelected === 3}
                                        >
                                        소속
                                    </DropdownItem> */}
                                </DropdownMenu>
                            </Dropdown>
                        </Col>
                    </Row>
                </Container>

                <Container>
                    <OrderPagination 
                        orders={filteredOrders} 
                        accounts={this.props.accounts}
                        products={this.props.products}
                        viewCount={10}
                        totalPage={Math.ceil(filteredOrders.length/10)}
                        viewingPage={0}
                    />
                </Container>
            </div>
       );
    }
}

const mapStateToProps = (state) => {
    return {
        orders : state.orders,
        accounts : state.accounts,
        products : state.products,
        ids : state.admin.orders.ids,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeOrderState : (ids, state) => {
            dispatch(orderActions.changeOrderState(ids, state))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderManager); 



// WEBPACK FOOTER //
// ./src/pages/Admin/OrderManager/OrderManager.js